var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 50,
    height: 35,
    rx: 3.5,
    fill: "#FBFCFF",
    stroke: "#D5E3ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Mastercard_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.674 25.861h8.652V10.14h-8.652V25.86Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.223 18c0 3.194 1.483 6.027 3.763 7.86A9.76 9.76 0 0 1 18.888 28C13.422 28 9 23.527 9 18c0-5.528 4.422-10 9.888-10a9.76 9.76 0 0 1 6.098 2.139c-2.28 1.805-3.763 4.666-3.763 7.86Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 18c0-5.528-4.422-10-9.888-10a9.759 9.759 0 0 0-6.098 2.139c2.307 1.833 3.763 4.667 3.763 7.861s-1.483 6.028-3.763 7.861A9.76 9.76 0 0 0 31.112 28C36.578 28 41 23.5 41 18Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Mastercard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(1 0 0 -1 9 28)",
    d: "M0 0h32v20H0z"
  })))));
};

export default SvgMastercard;